import { useContext } from 'react'

import { ApplicantDraft } from '../../RentalPortalApplicants.context'

import { getApplicantDraftSaveAction } from './useRentalPortalApplicantDraft.utils'

export function useRentalPortalApplicantDraft() {
  const { setDraft, ...draftContext } = useContext(ApplicantDraft)

  function handleSetDraft(nextDraftAction, timeout) {
    setDraft(getApplicantDraftSaveAction(nextDraftAction), timeout)
  }

  return { ...draftContext, setDraft: handleSetDraft }
}
